import { NgModule } from '@angular/core';
import { LibLockIconComponent } from './lib-lock-icon.component';

@NgModule({
  declarations: [LibLockIconComponent],
  imports: [],
  exports: [LibLockIconComponent],
})
export class LibLockIconModule {}
